import { millisecondsToPreciseDuration } from 'utils/date';
import { healthScore_v0 } from './healthScore_v0';
import { healthScore_v1 } from './healthScore_v1';
import { speedRun_v0 } from './speedRun_v0';
import { speedRun_v1 } from './speedRun_v1';

const convertTimes = (
  entries: {
    breakerId: string;
    additionalData: { time: number };
    position: number;
  }[],
) => {
  return entries.map((entry) => {
    return {
      ...entry,
      additionalData: {
        time: millisecondsToPreciseDuration(entry.additionalData.time * -1),
      },
    };
  });
};

const ARCHIVED_LEADERBOARDS = {
  HealthScore: [healthScore_v0, healthScore_v1],
  speedrunRecord: [convertTimes(speedRun_v0), convertTimes(speedRun_v1)],
};

export const getArchivedContestLeaderboard = (contestName: string, version: number) => {
  //@ts-ignore
  return ARCHIVED_LEADERBOARDS[contestName][version];
};
